import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Fader from '../Loaders/Fader';

import { setSession } from '../../../datastore/actions/sessionActions';
import { deleteCustomState } from '../../../util/LocalStorage';
import { SESSION_ID, SESSION_STATE, USER_DATA, USER_ROLES } from '../../../util/constants/AppConstants';
import { deleteDatabase } from '../../../util/LocalDb';

import SettingsIcon from '../../../assets/images/icons/settings.svg';
import './UserMenu.scss';

const UserMenu = ({ profileRef, setIsOpen, userInfo }) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleSettingsClick = () => {
    navigate('/settings');
    setIsOpen(false);
  };

  const handleLogout = () => {
    deleteCustomState(SESSION_STATE);
    deleteCustomState(SESSION_ID);
    deleteCustomState(USER_DATA);
    setIsOpen(false);
    deleteDatabase();
    dispatch(setSession(false));
    navigate('/');
    window.location.reload();
  };

  return (
    <div className="user-menu" ref={profileRef}>
      <div className="user-frame">
        <div className="username">
          {userInfo ? (
            <div className="username__data">
              {userInfo.firstname} {userInfo.lastname}
              <span>{USER_ROLES.find((role) => role.value == userInfo.role)?.short ?? ''}</span>
            </div>
          ) : (
            <Fader />
          )}
        </div>
      </div>
      <div className="user-image">
        {userInfo
          ? Array.from(userInfo.firstname.toUpperCase())[0] + Array.from(userInfo.lastname.toUpperCase())[0]
          : '...'}
      </div>
      <div className="user-info">
        <span className="email">{userInfo ? userInfo.email : '...'}</span>
        <span className="org">{userInfo ? userInfo.job : '...'}</span>
      </div>
      <div className="user-settings-wrap">
        <div className="user-settings" onClick={handleSettingsClick}>
          <img src={SettingsIcon} />
          Settings
        </div>
      </div>
      <div className="logout">
        <span className="create-btn" onClick={handleLogout}>
          Logout
        </span>
      </div>
    </div>
  );
};

export default UserMenu;
